export const codeToName = (code) => {
  let codeList = {
    's': 'success', 
    'e': 'error', 
    'w': 'warning',
    'i': 'info'
  }
  return codeList[code[0]]
}